import * as types from '../actions/actionTypes';
import * as jwtdecode from 'jwt-decode/lib';
import initialState from './initialState';
import { mustBeArray } from '../utils/lib';

function getUserFromToken(accessToken, idToken){
  let token = jwtdecode.default(accessToken);
  let roles = token && token.extension_userRole;
  if(roles){
    roles = roles.split(",");
  }
  return {
    user: {
      idToken: idToken,
      userName: token['signInNames.emailAddress'],
      id: token.extension_userId,
      roles: roles,
      name: token.name,
      hasRole: (role) => {
        if(!roles){
          return false;
        }
        let filtered = Array.isArray(roles) ?
          (roles.length == 1 ? (Array.isArray(roles[0]) ? roles[0].filter(x => x == role) : roles.filter(x => x == role)) : roles.filter(x => x == role)) :
          roles.filter(x => x == role);
        return filtered.length > 0;
      },
    }
  };
}

export default function accountReducer(state = initialState.account, action){
  switch(action.type) {
    case 'redux-oidc/USER_EXPIRED':
      //userManager.signinRedirect({state: window.location.pathname});
      return initialState.account;
    case 'redux-oidc/USER_FOUND':
       return getUserFromToken(action.payload.access_token, action.payload.id_token);
    case 'redux-oidc/LOADING_USER':
      return {
        user: {
          idToken: null,
          userName: '',
          roles: [],
          hasRole: (role) => {
            if(!this || !this.roles){
              return false;
            }
            let filtered = this.roles.filter(x => x == role);
            return filtered.length > 0;
          },
        }
      };
    default:
          return state;
  }
}
